define('all/template',['module', 'jquery', 'all/jquery/jquery.mustache', 'all/lazyloader'], function(module, $, $mustache) {
	'use strict';
	var configuration = module.config();

	function getWeekday(key) {
		return configuration.weekdays[key];
	}

	/**
	 * Basic templating jQuery plugin with support for multiple templates per element
	 *
	 * Set content of element to default template:
	 *     $('p').applyTemplate()
	 *
	 * Set content of element to <template data-name="plural", replacing %count% with 6:
	 *     $('p').applyTemplate({count: 6}, {template: 'plural'})
	 *
	 * Set content of element to <template data-name="singular", no replacement:
	 *     $('p').applyTemplate(undefined, {template: 'singular'})
	 *
	 * @param {Array|Object|undefined} data An object with named replacement values, such as {count: 6} -> replaces %count% with 6, or array of the same
	 * @param {object} [options] Additional options for applying the template
	 * @param {string} [options.template] The name of a specific template to use, this is the same name as used in the data-name attribute on the template tag.
	 * @param {string} [options.templateHtml] A string containing the template HTML, for that case when you can't actually put it into the DOM at all. Mostly applicable for table, tr and td.
	 * @param {boolean} [options.replace] Sets if the filled in template should replace all previous content or append to it. Defaults to true.
	 * @param {object} [options.into] An optional target where the filled in template is added into, defaults to being the parent of the template.
	 * @param {Date} [options.date] An optional date that will extend the provided data with the variables weekday, day, month, hour and minute.
     * @param {Boolean} [options.addBefore] Sets if the template will load before the content in into.
	 * @return {*}
	 */

	$.fn.applyTemplate = function(data, options) {
		if (typeof data === 'undefined') {
			data = {};
		}

		if (!$.isArray(data)) {
			data = [data];
		}

		var defaults = {
			templateHtml: undefined,
			template: undefined,
			replace: true,
			into: undefined,
			date: undefined,
            addBefore : false
		};

		options = $.extend(defaults, options);

		if (options.date) {
			var hour = options.date.getHours();
			var minute = options.date.getMinutes();
			if (hour < 10) {
				hour = '0' + hour;
			}
			if (minute < 10) {
				minute = '0' + minute;
			}
			for (var i = 0; i < data.length; i++) {
				$.extend(data[i], {
					weekday: getWeekday(options.date.getDay()),
					month: options.date.getMonth() + 1,
					day: options.date.getDate(),
					hour: hour,
					minute: minute
				});
			}
		}

		function getCurrentTarget($template) {
			if (options.into) {
				return options.into;
			}
			return $template.parent();
		}

		function findTemplate($el) {
			var templateSelector = 'template';
			if (options.template) {
				templateSelector += '[data-name=' + options.template + ']';
			} else {
				templateSelector += ':not([data-name])';
			}

			return $el.is('template') ? $el : $el.find(templateSelector);
		}

		return this.each(function() {
			var $this = $(this);
			var id = $this.attr('id') || $this.parents('[id]').first().attr('id') || 'unknown element';
			var templateHtml;
			var $target;
			if (options.templateHtml) {
				templateHtml = options.templateHtml;
				if (!options.into) {
					console.error('options.templateHtml can only be used in combination with options.into, otherwise it will not know where to go');
					return;
				}
				$target = options.into;
			} else {
				var $template = findTemplate($this);
				if($template.length === 0) {
					console.error(id, 'No template found');
					return;
				}
				templateHtml = $template.html();
				$target = getCurrentTarget($template);
			}

			$mustache.add(id, templateHtml);

			var html = [];

			// TODO: this should be possible without the loop, using jquery.mustache
			for (var i = 0; i < data.length; i++) {
				var currentData = $.extend({}, data[i]);
				html.push($mustache.render(id, currentData));
			}

			if (options.replace) {
				$target.contents().each(function() {
					var $content = $(this);
					if (!$content.is('template')) {
						$content.remove();
					}
				});
			}

            if(options.addBefore === 'undefined' || options.addBefore === false) {
                $target.append(html.join(''));
            }
            else{
                $target.prepend(html.join(''));
            }

			$target.lazyLoadSrc();
			//Workaround for Internet Explorer since it completely removes the style attribute if it cannot parse a part of it which happens when we have template variables in there
			//this allows you to have a data-style attribute instead that gets copied over after the template is applied
			$target.find('[data-style]').each(function () {
				$(this).attr('style', $(this).data('style'));
			});
		});
	};
});

